var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showDashboard
        ? _c(
            "v-layout",
            { attrs: { row: "", wrap: "", greyy: "" } },
            [
              _c("v-flex", { attrs: { xs12: "", md8: "", "offset-md2": "" } }, [
                _c("h1", { staticClass: "top-heading" }, [_vm._v("My Sales")])
              ]),
              _vm._v(" "),
              _vm.loading
                ? _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        md8: "",
                        "offset-md2": "",
                        "mt-5": "",
                        "text-xs-center": ""
                      }
                    },
                    [
                      _c("v-progress-circular", {
                        attrs: { indeterminate: "", color: "primary" }
                      })
                    ],
                    1
                  )
                : _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        md8: "",
                        "offset-md2": "",
                        "mt-5": "",
                        "text-xs-center": ""
                      }
                    },
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: { xs12: "", md6: "", left: "", floatNone: "" }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", paddingMobile: "" } },
                                [
                                  _c("div", { staticClass: "heading" }, [
                                    _vm._v("This Month")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "heading amount mt-2",
                                      class: _vm.getClass(_vm.thisMonth)
                                    },
                                    [
                                      _vm._v(
                                        "$" +
                                          _vm._s(
                                            _vm.numberWithCommas(
                                              parseFloat(_vm.thisMonth).toFixed(
                                                2
                                              )
                                            )
                                          )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "heading target" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.loggedInUser.position
                                          ? "Target = $" +
                                              _vm.numberWithCommas(
                                                parseFloat(
                                                  _vm.loggedInUser.position
                                                    .target
                                                ).toFixed(2)
                                              )
                                          : ""
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: { xs12: "", "mt-3": "", paddingMobile: "" }
                            },
                            [
                              _c("div", { staticClass: "heading" }, [
                                _vm._v("1 month prior")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "heading amount mt-2",
                                  class: _vm.getClass(_vm.oneMonthPrior)
                                },
                                [
                                  _vm._v(
                                    "$" +
                                      _vm._s(
                                        _vm.numberWithCommas(
                                          parseFloat(_vm.oneMonthPrior).toFixed(
                                            2
                                          )
                                        )
                                      )
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: { xs12: "", "mt-3": "", paddingMobile: "" }
                            },
                            [
                              _c("div", { staticClass: "heading" }, [
                                _vm._v("2 month prior")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "heading amount mt-2",
                                  class: _vm.getClass(_vm.twoMonthPrior)
                                },
                                [
                                  _vm._v(
                                    "$" +
                                      _vm._s(
                                        _vm.numberWithCommas(
                                          parseFloat(_vm.twoMonthPrior).toFixed(
                                            2
                                          )
                                        )
                                      )
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: { xs12: "", "mt-3": "", paddingMobile: "" }
                            },
                            [
                              _c("div", { staticClass: "heading" }, [
                                _vm._v("3 month prior")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "heading amount mt-2",
                                  class: _vm.getClass(_vm.threeMonthPrior)
                                },
                                [
                                  _vm._v(
                                    "$" +
                                      _vm._s(
                                        _vm.numberWithCommas(
                                          parseFloat(
                                            _vm.threeMonthPrior
                                          ).toFixed(2)
                                        )
                                      )
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          attrs: { xs12: "", md6: "", right: "", floatNone: "" }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", paddingMobile: "" } },
                                [
                                  _c("div", { staticClass: "heading" }, [
                                    _vm._v("Financial Year to Date")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "heading amount mt-2",
                                      class: _vm.getClass(_vm.orderTotal / 12)
                                    },
                                    [
                                      _vm._v(
                                        "$" +
                                          _vm._s(
                                            _vm.numberWithCommas(
                                              parseFloat(
                                                _vm.orderTotal
                                              ).toFixed(2)
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                "mt-5": "",
                                "pt-5": "",
                                paddingMobile: ""
                              }
                            },
                            [
                              _c("div", { staticClass: "heading pt-5" }, [
                                _vm._v("DIY Sales Today")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "heading amount mt-2",
                                  class: _vm.getClass2(_vm.salesToday)
                                },
                                [
                                  _vm._v(
                                    "$" +
                                      _vm._s(
                                        _vm.numberWithCommas(
                                          parseFloat(_vm.salesToday).toFixed(2)
                                        )
                                      )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "heading target" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.loggedInUser.position
                                      ? "Target = $" +
                                          _vm.numberWithCommas(
                                            parseFloat(
                                              _vm.setting.companyTarget
                                            ).toFixed(2)
                                          )
                                      : ""
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
            ],
            1
          )
        : _c(
            "v-layout",
            { attrs: { row: "", wrap: "", greyy: "" } },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    md8: "",
                    "offset-md2": "",
                    "mt-5": "",
                    "text-xs-center": ""
                  }
                },
                [_c("h1", [_vm._v("Nothing to show")])]
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37266e80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37266e80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MySales.vue
// module id = null
// module chunks = 